import {
    type DogSizeBucket,
    getDogSizeDisplayVerbose,
    getWeightBucket,
} from "@wags/catalog/pure.ts";
import type { ListingData } from "./listing-section-data";

export function mergeListingSizeFacts(
    base: ListingData,
    sourceSize: string | undefined,
) {
    const replacesBreed = Boolean(base.sizeFromBreed && sourceSize);
    return {
        sizeLabel: replacesBreed ? sourceSize : (base.sizeLabel ?? sourceSize),
        weightRange: replacesBreed ? undefined : base.weightRange,
        sizeFromBreed: base.sizeFromBreed && !sourceSize,
    };
}

export function getListingSizeDisplay(input: {
    listingWeightBucket: DogSizeBucket | null;
    listingWeightMinLbs: number | null;
    listingWeightMaxLbs: number | null;
    breedSize: string | null | undefined;
    breedWeightMinLbs: number | null | undefined;
    breedWeightMaxLbs: number | null | undefined;
}): { sizeLabel: string | undefined; weightRange: string | undefined } {
    const hasListingWeight =
        input.listingWeightMinLbs != null || input.listingWeightMaxLbs != null;
    const resolvedSize =
        input.listingWeightBucket ??
        (hasListingWeight ? undefined : getWeightBucket(input.breedSize));
    const weightMin = hasListingWeight
        ? input.listingWeightMinLbs
        : input.listingWeightBucket != null
          ? null
          : input.breedWeightMinLbs;
    const weightMax = hasListingWeight
        ? input.listingWeightMaxLbs
        : input.listingWeightBucket != null
          ? null
          : input.breedWeightMaxLbs;
    const weightRange =
        weightMin != null && weightMax != null
            ? weightMin === weightMax
                ? `${weightMin} lb`
                : `${weightMin}–${weightMax} lb`
            : (weightMin ?? weightMax) != null
              ? `${weightMin ?? weightMax} lb`
              : undefined;

    return {
        sizeLabel: getDogSizeDisplayVerbose(resolvedSize) ?? undefined,
        weightRange,
    };
}
